class OjaGirlGallery extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('[data-gallery-stage]');
    if (!this.stage) return;

    this.stage.addEventListener('pointerdown', this.onPointerDown);
    this.stage.addEventListener('pointermove', this.onPointerMove);
    this.stage.addEventListener('pointerup', this.onPointerUp);
    this.stage.addEventListener('pointercancel', this.onPointerUp);
    this.stage.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    this.stage?.removeEventListener('pointerdown', this.onPointerDown);
    this.stage?.removeEventListener('pointermove', this.onPointerMove);
    this.stage?.removeEventListener('pointerup', this.onPointerUp);
    this.stage?.removeEventListener('pointercancel', this.onPointerUp);
    this.stage?.removeEventListener('keydown', this.onKeydown);
  }

  onPointerDown = (event) => {
    if (event.pointerType === 'touch') return;
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScrollLeft = this.stage.scrollLeft;
    this.stage.setPointerCapture(event.pointerId);
    this.stage.setAttribute('data-dragging', '');
  };

  onPointerMove = (event) => {
    if (event.pointerId !== this.pointerId) return;
    event.preventDefault();
    this.stage.scrollLeft = this.startScrollLeft - (event.clientX - this.startX);
  };

  onPointerUp = (event) => {
    if (event.pointerId !== this.pointerId) return;
    if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
    this.pointerId = null;
    this.stage.removeAttribute('data-dragging');
  };

  onKeydown = (event) => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    const card = this.stage.querySelector('.oja-girl-gallery__card');
    if (!card) return;
    event.preventDefault();
    const gap = Number.parseFloat(getComputedStyle(this.stage).columnGap) || 0;
    this.stage.scrollBy({ left: (card.offsetWidth + gap) * (event.key === 'ArrowRight' ? 1 : -1), behavior: 'smooth' });
  };
}

if (!customElements.get('oja-girl-gallery')) {
  customElements.define('oja-girl-gallery', OjaGirlGallery);
}
